import { render, staticRenderFns } from "./GoogleSignin.vue?vue&type=template&id=8936123c&scoped=true&"
import script from "./GoogleSignin.ts?vue&type=script&lang=ts&"
export * from "./GoogleSignin.ts?vue&type=script&lang=ts&"
import style0 from "./GoogleSignin.css?vue&type=style&index=0&id=8936123c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8936123c",
  null
  
)

export default component.exports